import {useMemo} from 'react';
import {useSnackbar} from 'notistack';
import {useOnce, useQueryParam} from './react_hooks.js';
import api from './api.js';
import {useLoader} from '../components/Loader.js';

export const EmailVerificationProvider = props=>{
    let {children} = props;
    let {enqueueSnackbar} = useSnackbar();
    let [emailVerification, setEmailVerification] = useQueryParam('emailVerification');
    let [userId, token] = useMemo(()=>emailVerification?.split('-')||[], [emailVerification]);
    let [startLoading] = useLoader();
    useOnce(async ()=>{
        let stopLoading = startLoading('מאמת כתובת מייל...');
        try {
            let res = await api.verifyEmail({userId, token});
            if (res.verified)
                enqueueSnackbar('כתובת המייל אושרה, כעת ניתן להתחבר', {variant: 'success'});
        } catch (e) {
            let msg = e.code=='invalid_token' ? e.message : 'אירעה שגיאה, נסו שוב מאוחר יותר';
            enqueueSnackbar(msg, {variant: 'error'});
        } finally {
            setEmailVerification(null);
            stopLoading();
        }
    }, !!(userId&&token&&startLoading));
    return children;
};